import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import requester from '@/lib/axios';
import {
  FillInTheBlankQuestion,
  FillInTheBlankQuestionCreateDTO,
} from '@/models/Question';
import {
  convertToFormData,
  feedbacksConverter,
  jsonFieldConverter,
} from '@/utils/convertToFormData';
import { jsonToFormData } from '@/utils/shared/jsonToFormData';

const baseUrl = 'fill-in-the-blank-activity';

const converters = {
  title: jsonFieldConverter,
  context: jsonFieldConverter,
  feedbacks: feedbacksConverter,
};

export const getFillInTheBlankQuestion = async (id: number) => {
  const { data } = await requester().get<FillInTheBlankQuestion>(
    `${baseUrl}/${id}/`,
  );
  return data;
};

export const createFillInTheBlankQuestion = async ({
  title,
  context,
  feedbacks,
  ...body
}: Partial<FillInTheBlankQuestionCreateDTO>) => {
  const formData = jsonToFormData(body);
  convertToFormData({ title, context, feedbacks }, converters, formData);

  const { data } = await requester().post<FillInTheBlankQuestion>(
    `${baseUrl}/`,
    formData,
    { headers },
  );
  return data;
};

export const updateFillInTheBlankQuestion = async (
  id: number,
  {
    title,
    context,
    feedbacks,
    ...body
  }: Partial<
    Pick<
      FillInTheBlankQuestionCreateDTO,
      'title' | 'context' | 'question' | 'options' | 'feedbacks'
    >
  >,
) => {
  const formData = jsonToFormData(body);
  convertToFormData({ title, context, feedbacks }, converters, formData);

  const { data } = await requester().patch<FillInTheBlankQuestion>(
    `${baseUrl}/${id}/`,
    formData,
    { headers },
  );
  return data;
};

export const deleteFillInTheBlankQuestion = async (id: number) => {
  await requester().delete<FillInTheBlankQuestion>(`${baseUrl}/${id}/`);
};
